module.exports = __webpack_public_path__ + "static/img/5_2.ba426980.jpg";